// project imports
import Navigation from './Navigation';
import SimpleBar from '../../../..//components/third-party/SimpleBar';
// import { useGetMenuMaster } from '../../../../api/menu';

// ==============================|| DRAWER CONTENT ||============================== //

export default function DrawerContent() {

  return (
    <>
      <SimpleBar sx={{ '& .simplebar-content': { display: 'flex', flexDirection: 'column' }, position: 'absolute', overflow: "hidden", marginTop: "60px", maxWidth: '275px', width: '100%', maxHeight: 'none' }}>
        <Navigation />
      </SimpleBar>
    </>
  );
}
